module.exports = __webpack_public_path__ + "img/sidebar-arrow.fc193389.svg";